<div class="text-gray-700 ~text-2xl/5xl" id="kategorien">
    {{ data().title }}
</div>
<div class="flex justify-between gap-8 w-[180vw]" id="bestsellers-wrapper">
    @for (product of data().products; track $index) {
        <app-product
            class="min-w-56 h-[60vh]"
            [product]="product"
            [isLarge]="domHandler.isDesktop"
        ></app-product>
    }
    <a
        [routerLink]="[
            '/',
            this.languageService.getLanguageCode,
            'hof',
            'shop',
        ]"
        class="bottom-16 relative place-self-center border-2 border-t-0 border-r-0 border-b-primary border-l-0 w-fit h-fit text-nowrap animate-wiggle ~text-3xl/5xl"
    >
        {{ "footer.toShop" | translate }}
    </a>
</div>
